import { normalizeLinks } from './helpFunctions'
import { getPaginationModule } from './pagination'

import { RepositoryFactory } from '@/legacy/repositories/RepositoryFactory'

const StoreRepository = RepositoryFactory.get('store')

const links = getPaginationModule(StoreRepository.getLinkStats, normalizeLinks, {
  sortBy: 'clicks',
  sortOrder: 'desc',
})

export default links
